module.exports = __webpack_public_path__ + "static/media/bg-login.3c7c68ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-login.jpg
// module id = 227
// module chunks = 0